// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"802":"621f9f77","826":"d809cb1a"}[chunkId] + ".css";
};